export const SITE_URL = 'https://www.silkerai.com';

export const GITHUB_URL = 'https://github.com/niceappspl/silker-ai-sdk';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/silker-ai';
export const X_URL = 'https://x.com/jarzebowsky_dev';
export const X_HANDLE = '@jarzebowsky_dev';
export const NPM_PACKAGE = '@silker-ai/agent';
/** npmjs.com returns 403 to crawlers; GitHub repo is the canonical package page. */
export const NPM_PACKAGE_URL = GITHUB_URL;
export const OPENGRAPH_IMAGE = `${SITE_URL}/opengraph-image.png`;
